<template>
  <v-expansion-panel popout>
    <!--------------------------------------------------------------------
    | 1st - For rights (Inquiry rights) which are applied in filters.
    ---------------------------------------------------------------------->

    <v-expansion-panel-content v-for="(inquiry_right_id,index) in getInquiryRights()" :key="index">
      <template v-slot:header>
        <v-list two-line>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="title">
                <!-- Get the name of applied right's in filter -->
                {{ getTagName(inquiry_right_id,DEFINES.TAG_TYPE.FOR_RIGHTS) }}
              </v-list-tile-title>
              <v-list-tile-sub-title>
                <span>
                  <!-- Count of available countries for loop's filmright -->
                  <span class="green--text">{{ $t('rms.available.short_notation') }}&ensp;</span>
                  <span>{{findCountriesOfRequestedRightType(inquiry_right_id,'feasible_rights').length}}</span>
                </span>
                <span class="grey--text">&ensp;|&ensp;</span>
                <!-- Count of unavailable countries for loop's filmright -->
                <span>
                  <span
                    class="red--text font-weight-bold"
                  >{{ $t('rms.unavailable.short_notation') }} &ensp;</span>
                  <span>{{findCountriesOfRequestedRightType(inquiry_right_id,'unavailable_rights').length}}</span>
                </span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </template>
      <!-----------------------------------------------------------
      | 2nd - Now, find countries for all rights which are applied in filter
      ------------------------------------------------------------->
      <v-card>
        <v-card-text>
          <!-- here right_type is feasible(available) and unavailable -->
          <v-layout row wrap v-for="(right_type,i) in film_rights_type" :key="'rights'+i">
            <!--
              Check countries count for loop's filmright (the right which is running in loop)
              If it is more than 1 then proceed to get countries.
            -->
            <v-flex
              xs12
              v-if="findCountriesOfRequestedRightType(inquiry_right_id,right_type.title).length"
            >
              <v-subheader :class="['title','pl-0',right_type.color+'--text']">
                <v-icon :color="right_type.color">{{ $vuetify.icons[right_type.country_icon] }}</v-icon>&ensp;
                <span>{{right_type.country_text}}</span>&ensp;
                <v-divider></v-divider>
              </v-subheader>

              <v-layout row wrap>
                <v-flex
                  xs12
                  sm6
                  md6
                  lg4
                  class="mb-4"
                  v-for="(data,index) in getCountries(inquiry_right_id,right_type.title)"
                  :key="'country'+index"
                >
                  <v-layout row wrap>
                    <!--
                      Here countries are being get in alphabetical order,
                      so display the aplhabet first which is at "alphabet" key.
                    -->
                    <v-flex xs12 class="title font-weight-bold">{{ data.alphabet }}</v-flex>
                    <!--
                      Now, display all countries which are available on selected alphabet.
                      countries of any alphabet is at "record" key.
                    -->
                    <v-flex xs12 class="mt-1">
                      <span v-for="(country,index) in data.records" :key="index+'record'">
                        <span class="subheading">
                          {{country}}
                          <span
                            v-if="index+1 > 0 && index+1 < data.records.length"
                          >,&ensp;</span>
                        </span>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <!--
            If countries count is zero for both available and unavailable, then
            show message that no countries are available.
          -->
          <v-layout
            class="font-weight-bold"
            v-if="!findCountriesOfRequestedRightType(inquiry_right_id,'feasible_rights').length && !findCountriesOfRequestedRightType(inquiry_right_id,'unavailable_rights').length"
          >{{ $t('rms.film.film_rights.right_not_available_in_countries_label') }}</v-layout>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { doOrderAlphabetically } from "@/helper";

export default {
  data() {
    return {
      model: "tab-0",
      text: "Lorem ipsum dolor sit amet, consectetur",
      film_rights_type: [
        {
          title: "feasible_rights",
          country_text: this.$t("rms_countries_available_on_filmright"),
          color: "green",
          country_icon: "rms_check"
        },
        {
          title: "unavailable_rights",
          country_text: this.$t("rms_countries_unavailable_on_filmright"),
          color: "red",
          country_icon: "rms_close"
        }
      ]
    };
  },
  props: ["film"],
  computed: {
    ...mapState({
      filters: state => state.filter.filter,
      rights: state => state.tag.film_rights
    })
  },

  methods: {
    getTagName(tag_id, tag_type) {
      var tag = this.$store.getters["tag/getTag"](tag_id, tag_type);
      return tag.name;
    },

    getInquiryRights() {
      /**
       * If rights applied in filter then return the applied rights,
       * otherwise return all right from state.
       */
      return this.filters.rights && this.filters.rights.length
        ? this.filters.rights
        : this.rights.map(item => item.id);
    },

    getCountries(inquiry_right_id, right_type) {
      /*
      | --------------------------------------------------------------------------
      |  STEP-1 :-
      |  Get all countries (available Or unavailable)
      |  (available Or unavailable will decide by right_type)
      | --------------------------------------------------------------------------
      */
      let countries_ids = this.findCountriesOfRequestedRightType(
        inquiry_right_id,
        right_type
      );
      /*
      | --------------------------------------------------------------------------
      | STEP-2 :-
      | Now get names of countries from collection_ids which we
      | get from step-1.
      | --------------------------------------------------------------------------
      */
      let countries_names = this.getNamesOfCountries(countries_ids);
      /*
      | --------------------------------------------------------------------------
      | STEP-3 :-
      | Now make order of all countries alphabetically which we
      | get from step-2.
      | --------------------------------------------------------------------------
      */
      return doOrderAlphabetically(countries_names);
    },

    findCountriesOfRequestedRightType(inquiry_right_id, right_type) {
      /**
       * If requested right_type data is available on film
       * but not in form of array then convert it into array.
       */
      var data = [];
      if (!Array.isArray(this.film[right_type])) {
        this.film[right_type] = Object.values(this.film[right_type]);
      }
      /**
       * Here fimmrights are in format of "C.R"
       * so split the filmrights and get 1st index as country and 2nd as right.
       *
       */

      this.film[right_type].forEach(element => {
        if (element.split(".")[1] == inquiry_right_id) {
          data.push(element.split(".")[0]);
        }
      });

      return data;
    },

    getNamesOfCountries(country_ids) {
      let countries = [];
      country_ids.forEach(country_id => {
        countries.push(
          this.getTagName(country_id, this.DEFINES.TAG_TYPE.FOR_FILM_COUNTRIES)
        );
      });
      return countries;
    }
  }
};
</script>
